module.exports = __webpack_public_path__ + "static/media/LoteIntegracao.2f53a7d4.csv";